<template>
  <div class="wd-100p ht-100p">
    <!-- <Header></Header> -->
    <div class="wd-100p ht-100p">
      <div class="wd-100p ht-100p pos-r">

        <div class="wd-100p ht-100p ov-h ov-a-y">
          <div class="wd-100p ht-100p bg-white" v-animate="{ name: 'bounceInLeft', delay: 0 }">
            <div class="wd-100p pos-r dp-flex">
              <img v-if="!$store.state.mob" class="wd-100p" src="@/assets/home/bg.jpg" />
              <img v-else class="wd-100p ht-100vh" src="@/assets/home/bg_mob.jpg" />
              <div class="pos-a bg-1 dp-flex jus-c cr-white fw pointer"
                :class="$store.state.mob ? 'wd-60p left-20p bottom-26p font-30 ht-40' : 'wd-25p left-47p bottom-4p font-30 ht-60'"
                @click="clickref('/virtual')" v-animate="{ name: 'bounceInUp', delay: 600 }">
                Click to Experience
              </div>
            </div>
            <div class="pos-r" v-if="!$store.state.mob">
              <div class="wd-100p pos-a txt-ali-c cr-theme0 pd-20 font-18 Roboto lht-1d5">
                <b class="fong-20">FRASER RESIDENCE HANOI</b><br />
                C5, Do Nhuan Street, Xuan Dinh Ward, Bac Tu Liem District, Hanoi, Vietnam<br />
                <div class="dp-flex jus-c">
                  <div class="mg-l-r-10">Tel : +84 24 3275 0888</div>
                  <div class="mg-l-r-10">Fax: +84 24 3275 0899</div>
                  <div class="mg-l-r-10">Reservation Hotline No: +84 24 3275 0800</div>
                  <div class="mg-l-r-10">Email : <a class="cr-theme0" href="mailto:reservations.xuandinh-hanoi@frasershospitality.com">
                <u>reservations.xuandinh-hanoi@frasershospitality.com</u></a></div>
                </div>
                <img src="@/assets/virtual/icon_plane.png" class="mg-r5" />
                Airport transfer is upon request<br />
              </div>
              <img class="wd-100p" src="@/assets/home/foot.png" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/header.vue";
export default {
  components: {
    // Header,
  },
  data() {
    return {
      dynamicSlotName: "page",
      pages: 1, // 页面总数
      tempPage: 1,
      isV: true, //滚动的方向 true 为垂直方向，false 为左右方向
      page: 1, // 当前页面
      bgArr: [],
      config: {
        // 自动播放
        autoPlay: false,
        //  循环播放
        loop: false,
        // 切换间隔
        interval: 1000,
        // 上一页箭头
        lastArrow: false,
        // 下一页箭头
        nextArrow: false,
      },
    };
  },
  methods: {
    pointerMouseover({ event, index }) {
      console.log(event, index);
    },
    onRollEnd(page) {
      // console.log("当前页面为", page);
    },
    toPage() {
      this.page = this.tempPage;
    },
    clickref(ref) {
      this.pushr(ref);
    },
  },
  computed: {
  },
  created() { },
  mounted() {
    this.$store.dispatch("getMob");
  },
  watch: {},
  beforeDestroy() { },
};
</script>